import API from './api'
import axios from 'axios'
import { appEnvironment } from 'configs'

const apiClient = axios.create({
  baseURL:
    appEnvironment === 'production' ? `https://api.bookfocal.com/v2` : `https://api.dev.bookfocal.com/v2`,
  maxContentLength: 'Infinity',
  headers: {
    'Content-Type': 'application/json',
  },
})

// For receiving original(not coverted to camel case) freebusy response
export async function getOriginalFreeBusy(source, data) {
  const newData = {
    time_min: data.timeMin,
    time_max: data.timeMax,
    photographer_email: data.photographerEmail,
    callback: data.callback,
    items: data.items,
  }
  let response
  try {
    response = await apiClient.post(`calendar-free-busy/`, newData, {
      cancelToken: source.token,
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function getFreeBusy(source, data) {
  let response
  try {
    response = await API.post(`calendar-free-busy/`, data, {
      cancelToken: source.token,
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function listCalendarIDs(source, data) {
  let response
  try {
    response = await API.post(`calendar-list/`, data, {
      cancelToken: source.token,
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function patchCalendarEvents(token, data) {
  let response
  try {
    response = await API.patch(`calendar-events/`, data, { headers: { Authorization: `token ${token}` } })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function postCalendarEvents(token, data) {
  let response
  try {
    response = await API.post(`calendar-events/`, data, {
      headers: { Authorization: `token ${token}` },
    })
  } catch (error) {
    response = error.response
  }
  return response
}

export async function deleteCalendarAccount(source, data) {
  let response
  try {
    response = await API.post(`calendar-social-account/`, data, {
      cancelToken: source.token,
    })
  } catch (error) {
    response = error.response
  }
  return response
}
